import { SearchDNS } from "../config/apiServe/new-rpc";
import { isContractAddress } from "../config/apiServe/fetch-config.js";

export default {
    data() {
        return {
            Value: "",
            loading: false,
        };
    },
    computed: {
        maxHeight() {
            return this.$store.state.maxHeight;
        },
    },
    methods: {
        async search() {
            const reg = /^[0-9]*[1-9][0-9]*$/;
            this.Value = this.Value.trim();
            if (this.Value.trim() == "")
                return this.$toast(this.$t("home.keyword"));
            if (reg.test(this.Value.trim()) || this.Value == 0) {
                if (Number(this.Value.trim()) <= Number(this.maxHeight)) {
                    //判断两个高度差---int类型比较
                    this.loading = true;
                    this.Rpc.getBlockHash(Number(this.Value)).then((data) => {
                        if (data.error == null) {
                            this.$router.push({
                                name: "block",
                                params: {
                                    height: this.Value.trim(),
                                },
                            });
                            this.Value = "";
                            this.loading = false;
                        } else {
                            this.$toast(this.$t("components.errMsg"));
                            this.Value = "";
                            this.loading = false;
                        }
                    });
                } else {
                    this.$toast(this.$t("components.errHeight"));
                    this.Value = "";
                }
            } else {
                let e = this.Value.length;
                if (e === 66 || e === 64) {
                    this.Value = e === 64 ? "0x" + this.Value : this.Value;
                    //交易的哈希值---地址64位字节加上16进制标示0x(共66位)
                    this.loading = true;
                    this.Rpc.queryTransaction(this.Value).then((data) => {
                        if (data.error == null) {
                            this.$router.push({
                                name: "tradeHash",
                                params: {
                                    hash: this.Value,
                                },
                            });
                            this.Value = "";
                            this.loading = false;
                        } else {
                            //区块哈希
                            this.Rpc.getBlockOverview(this.Value).then(
                                (data) => {
                                    if (data.error == null) {
                                        this.$router.push({
                                            name: "block",
                                            params: {
                                                height: data.result.head.height,
                                            },
                                        });
                                        this.Value = "";
                                        this.loading = false;
                                    } else {
                                        this.$toast(
                                            this.$t("components.errMsg")
                                        );
                                        this.Value = "";
                                        this.loading = false;
                                    }
                                }
                            );
                        }
                    });
                } else {
                    // 域名
                    const regweb = /^bty\..*.\.yuan$/;
                    let dns;
                    if (
                        this.Value.slice(-5) == ".yuan" &&
                        this.Value.slice(0, 4) != "bty."
                    )
                        dns = "bty." + this.Value;
                    else dns = this.Value;
                    if (regweb.test(dns)) {
                        this.loading = true;
                        try {
                            const res = await SearchDNS(dns);
                            this.Rpc.getAddrOverview(res.data[0]).then(
                                (data) => {
                                    if (data.error == null) {
                                        this.$router.push({
                                            name: "address",
                                            params: {
                                                address: res.data[0],
                                                way: 0,
                                            },
                                        });
                                        this.Value = "";
                                        this.loading = false;
                                    } else {
                                        this.$toast(
                                            this.$t("components.errMsg")
                                        );
                                        this.Value = "";
                                        this.loading = false;
                                    }
                                }
                            );
                        } catch (error) {
                            this.loading = false;
                        }
                    } else {
                        //地址
                        this.loading = true;
                        this.Rpc.getAddrOverview(this.Value).then((data) => {
                            if (data.error == null) {
                                // 检测是否为合约地址
                                isContractAddress(this.Value).then((res) => {
                                    if (res.result) {
                                        this.$router.push({
                                            name: "contract",
                                            params: {
                                                address: this.Value,
                                                way: 0,
                                            }})
                                    }
                                    else
                                        this.$router.push({
                                            name: "address",
                                            params: {
                                                address: this.Value,
                                                way: 0,
                                            },
                                        });
                                    this.Value = "";
                                })
                                this.loading = false;
                            } else {
                                this.$toast(this.$t("components.errMsg"));
                                this.Value = "";
                                this.loading = false;
                            }
                        });
                    }
                }
            }
        },
    },
};
